import { trim } from "@/helpers/string.helpers"
import { PayloadHandler, type Values } from "./payload.handler"

export class ConditionsHandler extends PayloadHandler {
  public handle(request: Values) {
    const { conditions = [], ...rest } = request as {
      conditions?: { key?: string; value: string; selectedValue: unknown }[][]
    }

    if (!Array.isArray(conditions))
      return super.handle({ conditions: [], ...rest })

    return super.handle({
      conditions: conditions
        .filter((value) => !!value?.length)
        .map((value) =>
          value.reduce(
            (acc, condition) => {
              const { value, key = value, selectedValue } = condition

              acc[key] = trim(selectedValue)

              return acc
            },
            {} as Record<string, unknown>
          )
        ),
      ...rest
    })
  }
}
